var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormRender',{attrs:{"form":_vm.form,"is-edit":_vm.isEdit,"get-url":_vm.getEndpoint,"save-url":_vm.saveEndpoint,"on-saved":_vm.handlerSaved,"success-message":_vm.successMessage},model:{value:(_vm.dataDocument),callback:function ($$v) {_vm.dataDocument=$$v},expression:"dataDocument"}})
}
var staticRenderFns = []

export { render, staticRenderFns }